// 后端字段使用 0/1：0=选填，1=必填
export const PRIVACY_CHECK_REQUIRED_DEFAULT = '0';
export const PRIVACY_CHECK_ERROR_TIP_DEFAULT = 'This field is required.';
export const PRIVACY_CHECK_DEFAULTS = {
  privacyCheckRequired: PRIVACY_CHECK_REQUIRED_DEFAULT,
  privacyCheckErrorTip: PRIVACY_CHECK_ERROR_TIP_DEFAULT
};
export const SUBSCRIBE_SIGNUP_TIP_DEFAULT = 'You are already subscribed.';

export const fontFaceList = [
  {
    name: 'Arial',
    value: 'Arial, sans-serif',
    isBrandFont: false
  },
  {
    name: 'Courier New',
    value: 'Courier New, monospace',
    isBrandFont: false
  },
  {
    name: 'Georgia',
    value: 'Georgia, serif',
    isBrandFont: false
  },
  {
    name: 'Times New Roman',
    value: 'Times New Roman, serif',
    isBrandFont: false
  },
  {
    name: 'Trebuchet MS',
    value: 'Trebuchet MS, sans-serif',
    isBrandFont: false
  },
  {
    name: 'Verdana',
    value: 'Verdana, sans-serif',
    isBrandFont: false
  },
  {
    name: 'AbrilFatface',
    value: 'CartxAbrilFatface',
    isBrandFont: true
  },
  {
    name: 'Antonio',
    value: 'CartxAntonio',
    isBrandFont: true
  },
  {
    name: 'Atkinson-Hyperlegible-Bold-Italic-102',
    value: 'CartxAtkinsonHyperlegibleBoldItalic102',
    isBrandFont: true
  },
  {
    name: 'DancingScript',
    value: 'CartxDancingScript',
    isBrandFont: true
  },
  {
    name: 'DellaRespira',
    value: 'CartxDellaRespira',
    isBrandFont: true
  },
  {
    name: 'Dosis',
    value: 'CartxDosis',
    isBrandFont: true
  },
  {
    name: 'Helvetica',
    value: 'CartxHelvetica',
    isBrandFont: true
  },
  {
    name: 'LDFComicSans',
    value: 'CartxLDFComicSans',
    isBrandFont: true
  },
  {
    name: 'LobsterTwo',
    value: 'CartxLobsterTwo',
    isBrandFont: true
  },
  {
    name: 'Lovelo',
    value: 'CartxLovelo',
    isBrandFont: true
  },
  {
    name: 'Morganite',
    value: 'CartxMorganite',
    isBrandFont: true
  },
  {
    name: 'NotCourierSans',
    value: 'CartxNotCourierSans',
    isBrandFont: true
  },
  {
    name: 'NoticiaTextItalic',
    value: 'CartxNoticiaTextItalic',
    isBrandFont: true
  },
  {
    name: 'PermianSansTypeface',
    value: 'CartxPermianSansTypeface',
    isBrandFont: true
  },
  {
    name: 'Promesh',
    value: 'CartxPromesh',
    isBrandFont: true
  },
  {
    name: 'Roboto',
    value: 'CartxRoboto',
    isBrandFont: true
  },
  {
    name: 'Rubik',
    value: 'CartxRubik',
    isBrandFont: true
  },
  {
    name: 'SyncopateRegular',
    value: 'CartxSyncopateRegular',
    isBrandFont: true
  },
  {
    name: 'Vnantiq',
    value: 'CartxVnantiq',
    isBrandFont: true
  },
  {
    name: 'Zaio',
    value: 'CartxZaio',
    isBrandFont: true
  },
  {
    name: 'AlegreyaSans-Bold',
    value: 'CartxAlegreyaSansBold',
    isBrandFont: true
  },
  {
    name: 'AlegreyaSans-Medium',
    value: 'CartxAlegreyaSansMedium',
    isBrandFont: true
  },
  {
    name: 'AlegreyaSansSC-ExtraBold',
    value: 'CartxAlegreyaSansSCExtraBold',
    isBrandFont: true
  },
  {
    name: 'DidactGothic',
    value: 'CartxDidactGothic',
    isBrandFont: true
  },
  {
    name: 'EBGaramond-Regular',
    value: 'CartxEBGaramondRegular',
    isBrandFont: true
  },
  {
    name: 'Futura-Medium',
    value: 'CartxFuturaMedium',
    isBrandFont: true
  },
  {
    name: 'LibreFranklin-Regular',
    value: 'CartxLibreFranklinRegular',
    isBrandFont: true
  },
  {
    name: 'Lora-Regular',
    value: 'CartxLoraRegular',
    isBrandFont: true
  },
  {
    name: 'Montserrat-Regular',
    value: 'CartxMontserratRegular',
    isBrandFont: true
  },
  {
    name: 'OpenSans-Regular',
    value: 'CartxOpenSansRegular',
    isBrandFont: true
  },
  {
    name: 'PT_Sans-Narrow-Web-Regular',
    value: 'CartxPTSansNarrowWebRegular',
    isBrandFont: true
  },
  {
    name: 'Raleway-Regular',
    value: 'CartxRalewayRegular',
    isBrandFont: true
  },
  {
    name: 'Roboto-Condensed',
    value: 'CartxRobotoCondensed',
    isBrandFont: true
  },
  {
    name: 'NotoSansJP-Regular',
    value: 'CartxNotoSansJPRegular',
    isBrandFont: true
  },
  {
    name: 'NotoSerifJP-Regular',
    value: 'CartxNotoSerifJPRegular',
    isBrandFont: true
  }
];

export const predefineColors = [
  '#ff4500',
  '#ff8c00',
  '#ffd700',
  '#90ee90',
  '#00ced1',
  '#1e90ff',
  '#c71585',
  '#f1b859',
  '#f4994b',
  '#d7394d',
  '#dd5b46',
  '#f7d69e',
];

/** 与关闭按钮设置「背景颜色」一致：支持 rgba 透明度预设 */
export const rgbaBackgroundPredefineColors = [
  '#000000',
  '#333333',
  '#666666',
  '#999999',
  '#CCCCCC',
  '#FFFFFF',
  '#FF0000',
  '#00FF00',
  '#0000FF',
  '#FFFF00',
  '#FF00FF',
  '#00FFFF',
  '#C30D23',
  '#0F1222',
  '#513EFF',
  'rgba(0,0,0,0)',
  'rgba(0,0,0,0.5)',
  'rgba(255,255,255,0.8)'
];

export const shortFormAddList = [{
    label: "Email",//,名称
    necessary : true, //是否必填
    placeholder: "Email Address",//输入框提示文本
    type: "Email",//校验input所用字段
    attribute: "Email",//校验input所用字段
    max: 30,
    routine : true, //和自定义区别的 是否是常规字段

    tipEmptyEmailText: 'Please enter email',
    tipInvalidEmailText: 'Please enter a valid email',
    formSubscribeSignup: false,
    tipSubscribeEmailText: SUBSCRIBE_SIGNUP_TIP_DEFAULT,

    enablePrivacyCheck: false,
    enablePrivacyCheckValue: 'on',

    enablePrivacyShow: false,
    /** 端隐私勾选必填设置（默认选填，存量模板兼容） */
    ...PRIVACY_CHECK_DEFAULTS,
    /** 隐私文案 */
    text: 'Subscribe to marketing emails and our ',
    /** 隐私政策链接按钮文本 */
    linkText: 'Privacy Policy',
  },
  {
    label: 'Phone Number',//,名称
    necessary : true, //是否必填
    placeholder: "Phone Number",//输入框提示文本
    type: "Mobile Number",//校验input所用字段
    attribute: "Mobile Number",//
    phoneCountryAbbreviation: 'US',
    enablePrivacyCheck:false,
    enablePrivacyCheckValue:'on',
    phoneCode: '+1',
    max: 30,
    routine : true, //和自定义区别的 是否是常规字段
    text:'I would like to receive marketing text messages at the number provided. Message frequency varies. Consent is not a condition of purchase. Reply HELP for help, STOP to unsubscribe. Message and data rates may apply.Check our ',
    linkText:'privacy policy', //隐私政策链接按钮文本
    tipEmptyPhoneText:'Enter Mobile Number', // 必填信息提示
    tipInvalidPhoneText:'Invalid phone number', // 错误信息提示
    formSubscribeSignup: false,
    tipSubscribePhoneText: SUBSCRIBE_SIGNUP_TIP_DEFAULT,
    /** 端隐私勾选必填设置（默认选填，存量模板兼容） */
    ...PRIVACY_CHECK_DEFAULTS,
  }
]

export const formAddList = [
  {
    label: "Email",//,名称
    necessary : true, //是否必填
    placeholder: "Email Address",//输入框提示文本
    type: "Email",//校验input所用字段
    attribute: "Email",//校验input所用字段
    max: 30,
    routine : true, //和自定义区别的 是否是常规字段

    tipEmptyEmailText: 'Please enter email',
    tipInvalidEmailText: 'Please enter a valid email',
    formSubscribeSignup: false,
    tipSubscribeEmailText: SUBSCRIBE_SIGNUP_TIP_DEFAULT,

    enablePrivacyCheck: false,
    enablePrivacyCheckValue: 'on',

    enablePrivacyShow: false,
    /** 端隐私勾选必填设置（默认选填，存量模板兼容） */
    ...PRIVACY_CHECK_DEFAULTS,
    /** 隐私文案 */
    text: 'Subscribe to marketing emails and our ',
    /** 隐私政策链接按钮文本 */
    linkText: 'Privacy Policy'
  },
  {
    label: 'Phone Number',//,名称
    necessary : true, //是否必填
    placeholder: "Phone Number",//输入框提示文本
    type: "Mobile Number",//校验input所用字段
    attribute: "Mobile Number",//
    phoneCountryAbbreviation: 'US',
    enablePrivacyCheck:false,
    enablePrivacyCheckValue:'on',
    phoneCode: '+1',
    max: 30,
    routine : true, //和自定义区别的 是否是常规字段
    text:'I would like to receive marketing text messages at the number provided. Message frequency varies. Consent is not a condition of purchase. Reply HELP for help, STOP to unsubscribe. Message and data rates may apply.Check our ',
    linkText:'privacy policy', //隐私政策链接按钮文本
    tipEmptyPhoneText:'Enter Mobile Number', // 必填信息提示
    tipInvalidPhoneText:'Invalid phone number', // 错误信息提示
    formSubscribeSignup: false,
    tipSubscribePhoneText: SUBSCRIBE_SIGNUP_TIP_DEFAULT,
    /** 端隐私勾选必填设置（默认选填，存量模板兼容） */
    ...PRIVACY_CHECK_DEFAULTS,
  },
  {
    label: 'Birthday',//,名称
    necessary : false, //是否必填
    placeholder: "Birthday",//输入框提示文本
    type: "Birthday",//校验input所用字段
    attribute: "Birthday",//
    max: 30,
    routine : true //和自定义区别的 是否是常规字段
  },
  {
    label: 'First Name',//,名称
    necessary : false, //是否必填
    placeholder: "First Name",//输入框提示文本
    type: "First Name",//校验input所用字段
    attribute: "First Name",//
    max: 30,
    routine : true //和自定义区别的 是否是常规字段
  },
  {
    label: 'Last Name',//,名称
    necessary : false, //是否必填
    placeholder: "Last Name",//输入框提示文本
    type: "Last Name",//
    max: 30,
    routine : true, //和自定义区别的 是否是常规字段
    attribute:"Last Name"//属性
  },
  {
    label: 'Country',//,名称
    necessary : false, //是否必填
    placeholder: "Country",//输入框提示文本
    type: "Country",//
    max: 30,
    routine : true, //和自定义区别的 是否是常规字段
    attribute:"Country"//属性
  },

  {
    label: 'Province',//,名称
    necessary : false, //是否必填
    placeholder: "Province",//输入框提示文本
    type: "Province",//
    max: 30,
    routine : true, //和自定义区别的 是否是常规字段
    attribute:"Province"//属性
  },
  {
    label: 'City',//,名称
    necessary : false, //是否必填
    placeholder: "City",//输入框提示文本
    type: "City",//
    max: 30,
    routine : true, //和自定义区别的 是否是常规字段
    attribute:"City"//属性
  },
  {
    label: '自定义',//,名称
    necessary : true, //是否必填
    type: "自定义",//校验input所用字段
    max: 100,
    routine : false, //和自定义区别的 是否是常规字段
    optionList: [
      {},
    ],
    questionType:'Single',//单选多选
    question:'',//问题名称
    attributeId:undefined,
    attribute:''//属性
  },
];

export const countdownTimeOption = [
  {label:'分钟',value:"minute"},
  {label:'秒',value:"second"},
];

export const borderRadiusOptions = [
  {name: '0', value: '0'},
  {name: '4', value: '4px'},
  {name: '6', value: '6px'},
  {name: '8', value: '8px'},
  {name: '16', value: '16px'},
  {name: '全圆角', value: '1000px'}, // 不能设置50%， 会变成椭圆
];

export const borderStyleOptions = [
  {name: '无', value: 'none'},
  {name: '实线', value: 'solid'},
  {name: '虚线', value: 'dashed'},
];
export const typesettingOptions = [
  {name: '左图', value: 'left'},
  {name: '右图', value: 'right'},
  {name: '上图', value: 'top'},
  {name: '中图', value: 'middle'},
  {name: '背景图', value: 'background'},
  {name: '无图', value: 'none'},
];

export const typesettingOptions1 = [
  {name: '左图', value: 'left'},
  {name: '右图', value: 'right'},
  {name: '上图', value: 'top'},
  {name: '中图', value: 'middle'},
]

/** 转盘组合布局 popWindowWheel=2：侧图仅支持左/右 */
export const typesettingOptionsLeftRightOnly = [
  {name: '左图', value: 'left'},
  {name: '右图', value: 'right'},
];

export const fontSizeOptions = ['12px', '13px', '14px', '15px', '16px', '17px', '18px', '19px', '20px', '21px', '22px', '23px', '24px', '25px', '26px', '27px', '28px', '29px', '30px', '31px', '32px', '33px', '34px', '35px', '36px', '37px', '38px', '39px', '40px', '41px', '42px', '43px', '44px', '45px', '46px', '47px', '48px', '49px', '50px'];

export const fontSizeSmallOptions = ['10px', '11px', '12px', '13px', '14px', '15px', '16px'];

export const backgroundOptions = [
  {value: 'none', name: '无背景'},
  {value: '', name: '有背景'}
]

export const containerBorderRadiusOptions = [
  {name: '0', value: '0px'},
  {name: '4', value: '4px'},
  {name: '8', value: '8px'},
  {name: '16', value: '16px'},
];
/**
 * 弹窗/转盘类型枚举
 * 用于 popWindowWheel 字段
 */
export const POP_WINDOW_WHEEL_TYPE = {
  /** 普通弹窗 */
  POP: 0,
  /** 转盘 */
  WHEEL: 1,
  /** 转盘组合布局（侧图） */
  WHEEL_COMBO: 2,
} as const;
